export default __webpack_public_path__ + "static/media/logo.adda6017.jpg";